import api from "./api";

const MaterialConsumptionReportService = {
    getReport: async (params) => {
        const response = await api.get(
            "/materialConsumptionReport/getReport",
            {
                params: {
                    companyId: params.companyId || undefined,
                    employeeId: params.employeeId || undefined,
                    roleId: params.roleId || undefined,
                    projectCategoryId: params.projectCategoryId || undefined,
                    projectId: params.projectId || undefined,
                    locationId: params.locationId || undefined,
                    itemCategoryId: params.itemCategoryId || undefined,
                    itemCode: params.itemCode || undefined,
                    page: params.page || 1,
                    limit: params.limit || 10,
                },
            }
        );
        return response.data;
    },

    exportExcel: async (params) => {
        const response = await api.get(
            "/materialConsumptionReport/exportExcel",
            {
                params: {
                    companyId: params.companyId || undefined,
                    employeeId: params.employeeId || undefined,
                    roleId: params.roleId || undefined,
                    projectCategoryId: params.projectCategoryId || undefined,
                    projectId: params.projectId || undefined,
                    locationId: params.locationId || undefined,
                    itemCategoryId: params.itemCategoryId || undefined,
                    itemCode: params.itemCode || undefined,
                },
            }
        );
        return response.data?.data || [];
    }
};

export default MaterialConsumptionReportService;
